exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hooper-container .hooper{height:100%}.hooper-container .hooper:focus{outline:none}.hooper-container .hooper .hooper-list:focus{outline:none}.hooper-container .hooper .hooper-track:focus{outline:none}.hooper-container .hooper .hooper-next{display:none}.hooper-container .hooper .hooper-prev{display:none}.hooper-container .hooper .hooper-slide{border:none !important;outline:none !important}.hooper-container .hooper .hooper-slide:focus{outline:none;border:none}\n", ""]);

// exports
